import type { SelectItem } from '@vrplatform/components';
import type { RequestQuery, ResponseData } from '@vrplatform/data';
import { formatOwnerName } from '@vrplatform/ui-common';

export const DEFAULT_CONTACTS_FILTER_LIMIT = 50;

type ContactFilterType = 'owner' | 'vendor' | 'all';

type ContactOptionSource = Pick<
  ResponseData<'get:/contacts'>['data'][number],
  'firstName' | 'id' | 'name'
>;

export function getContactsFilterQuery({
  page,
  search,
  type,
}: {
  page: number;
  search?: string;
  type: ContactFilterType;
}): RequestQuery<'get:/contacts'> {
  return {
    limit: DEFAULT_CONTACTS_FILTER_LIMIT,
    page,
    search: search?.trim() || undefined,
    status: 'active',
    type: type === 'all' ? undefined : type,
  };
}

export function mapContactToSelectItem(
  contact: ContactOptionSource
): SelectItem {
  return {
    value: contact.id,
    label: formatOwnerName(contact),
  };
}
